module.exports = __webpack_public_path__ + "static/media/wedding-catering.16091319.jpg";